/* eslint-disable max-len */
import Question from 'images/coin-pages/questions/id.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const idPage: ICoinPageData = {
  title: 'coin_488',
  description: 'coin_489',
  // description: 'coin_490',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Space ID (ID)' }) }} />
  ),
  questionsBlock: {
    image: Question,
    questions: [
      {
        title: 'coin_491',
        answer: 'coin_492',
      },
      {
        title: 'coin_493',
        answer: 'coin_494',
      },
      {
        title: 'coin_495',
        answer: 'coin_496',
      },
      {
        title: 'coin_497',
        answer: 'coin_498',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Space ID (ID)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_499',
        text: ['coin_501'],
      },
      {
        title: 'coin_500',
        text: ['coin_502'],
      },
    ],
    blogCards: [blogCards.borrowLikePro, blogCards.cryptoCrash],
  },
}
